import React from 'react';
import  Sramdhan2024  from 'views/Sramdhan2024';
const BlogNewsroomPage = () => {
return <Sramdhan2024/>
};
export default BlogNewsroomPage;